import { Injectable } from '@angular/core';
import { OperationsService } from '../base/operations.service';
import { AttachOperation } from './attach-operation';

@Injectable({
  providedIn: 'root',
})
export class AttachOperationsService extends OperationsService<AttachOperation> {
  addOperation(): AttachOperation {
    const operation = new AttachOperation(this._operations$);
    this._operations$.next([...this._operations$.value, operation]);
    return operation;
  }
}
